import { MidasEffectError, OverviewLocationsCoordinates } from "@midas/shared/common";
import { createAction, props } from "@ngrx/store";

export const wasteLocations = createAction('[Overview/Locations] Waste Locations');
export const wasteLocationsSuccess = createAction('[Overview/Locations] Waste Locations Success', props<{data: OverviewLocationsCoordinates}>());

export const wasteLocationsError = createAction('[Overview/Locations] Waste Locations Error', props<MidasEffectError>());
